var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { scrollX } from '@finect/tabular-utils/scrollX';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var tabsStyles = css(["position:relative;margin-bottom:24px;"]);
var chipsStyles = css(["margin-bottom:24px;"]);
var columnsStyles = css(["display:grid;height:100%;grid-template-rows:repeat(1,1fr);grid-auto-columns:1fr;grid-auto-flow:column;grid-gap:18px;", " ", ""], minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["grid-template-rows: repeat(2, 1fr);"]))), minMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["grid-template-rows: repeat(4, 1fr);"]))));
var modulesStyles = css(["display:flex;flex-direction:column;height:100%;", ""], maxMediaQueries.tablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex-direction: row;\n    flex-wrap: nowrap;\n    overflow-x: auto;\n    "]))));
export var TabList = styled.div.withConfig({
  displayName: "TabList",
  componentId: "sc-54l64f-0"
})(["scroll-behavior:smooth;display:flex;flex-wrap:", ";", " ", ";", ";", ";", ";", ""], function (_ref) {
  var _ref$$wrap = _ref.$wrap,
    $wrap = _ref$$wrap === void 0 ? 'nowrap' : _ref$$wrap;
  return $wrap;
}, function (_ref2) {
  var _ref2$$wrap = _ref2.$wrap,
    $wrap = _ref2$$wrap === void 0 ? 'nowrap' : _ref2$$wrap;
  return $wrap === 'nowrap' && scrollX;
}, function (_ref3) {
  var $variant = _ref3.$variant;
  return $variant === 'tabs' && tabsStyles;
}, function (_ref4) {
  var $variant = _ref4.$variant;
  return ['chips', 'chipsPlus'].includes($variant) && chipsStyles;
}, function (_ref5) {
  var $variant = _ref5.$variant;
  return $variant === 'modulesPlus' && modulesStyles;
}, function (_ref6) {
  var $variant = _ref6.$variant;
  return $variant === 'columns' && columnsStyles;
}, minMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref7) {
  var center = _ref7.center;
  return center && 'justify-content: center;';
}));
export var ActionButton = styled.button.withConfig({
  displayName: "TabList__ActionButton",
  componentId: "sc-54l64f-1"
})(["position:absolute;top:0;visibility:visible;opacity:0.75;width:24px;height:32px;border:1px solid ", ";border-radius:3px;cursor:pointer;background-color:", ";color:", ";transition:opacity 0.25s ease;", " ", " svg{position:relative;", " ", "}:hover{opacity:1;background-color:", ";color:", ";}", ""], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.ui;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.uiL;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.uiD;
}, function (_ref11) {
  var $type = _ref11.$type;
  return $type === 'prev' && 'left: -30px;';
}, function (_ref12) {
  var $type = _ref12.$type;
  return $type === 'next' && 'right: 0; right: -30px;';
}, function (_ref13) {
  var $type = _ref13.$type;
  return $type === 'prev' && 'left: -4px;';
}, function (_ref14) {
  var $type = _ref14.$type;
  return $type === 'next' && 'left: -3px;';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.uiL;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.uiDD;
}, function (_ref17) {
  var $variant = _ref17.$variant,
    $type = _ref17.$type;
  return $variant === 'columns' && css(["", " top:50%;transform:translateY(-50%);width:32px;height:32px;border-radius:50%;", " ", " svg{position:relative;", " ", "}"], $type === 'prev' ? 'left: 0px;' : '', maxMediaQueries.miniDesktop(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        ", "\n        ", "\n      "])), $type === 'prev' ? 'left: 17px;' : '', $type === 'next' ? 'right: -14px;' : ''), maxMediaQueries.tablet(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        ", "\n        ", "\n      "])), $type === 'prev' ? 'left: -14px;' : '', $type === 'next' ? 'right: -14px;' : ''), $type === 'prev' ? 'left: -1px;' : '', $type === 'next' ? 'left: 1px;' : '');
});
export var ListBlock = styled.div.withConfig({
  displayName: "TabList__ListBlock",
  componentId: "sc-54l64f-2"
})(["width:100%;margin-left:0;margin-right:0;"]);
export var TabsBlock = styled.div.withConfig({
  displayName: "TabList__TabsBlock",
  componentId: "sc-54l64f-3"
})(["position:relative;", "{display:none;", " ", "}:hover{", "{visibility:visible;opacity:1;}}", " ", ""], ActionButton, minMediaQueries.miniDesktop(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      display: block\n    "]))), function (_ref18) {
  var $variant = _ref18.$variant;
  return $variant === 'columns' && css(["display:block;z-index:1;"]);
}, ActionButton, function (_ref19) {
  var $variant = _ref19.$variant;
  return !['chips', 'chipsPlus'].includes($variant) && css(["", "{margin-left:0;margin-right:0;}"], ListBlock);
}, function (_ref20) {
  var $variant = _ref20.$variant;
  return $variant === 'columns' && css(["display:flex;float:right;flex-direction:column;flex-wrap:wrap;justify-content:space-between;width:50%;padding-left:30px;", ""], maxMediaQueries.tablet(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        width: 100%;\n        float: none;\n        padding-left: 0;\n      "]))));
});